module.exports = __webpack_public_path__ + "img/time.dc8bf6bc.svg";